// extracted by mini-css-extract-plugin
export default {"MainCont":"MakeUp_MainCont__xI3r6","RightCont":"MakeUp_RightCont__rm4BK"};